import { render, staticRenderFns } from "./UpgradePackageTemplateList.vue?vue&type=template&id=494a7d4e"
import script from "./UpgradePackageTemplateList.vue?vue&type=script&lang=js"
export * from "./UpgradePackageTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports